import React, { useState } from "react";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SearchIcon from "@mui/icons-material/Search";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

import { deleteWish } from "../store/slices/userSlice";
import { getProductUrl } from "../utils/productUrl";

const wishlistItemText = {
  smartphone: "Телефон",
  accessory: "Галантерија",
  preview: "Преглед",
  toCart: "Во кошничка",
  addedSuffix: "е додаден во",
  cart: "кошничката",
};

function WishlistSingle({ product }) {
  const [showAdded, setShowAdded] = useState(false);
  const dispatch = useDispatch();

  const deleteItem = () => {
    dispatch(deleteWish(product.id));
  };

  const handleAddCartItem = () => {
    let current = sessionStorage.getItem("cart");

    if (!current) {
      current = [];
    } else {
      current = JSON.parse(current);
    }

    if (current.some((entry) => entry.id === product.id)) {
      const objIndex = current.findIndex((obj) => obj.id === product.id);
      current[objIndex].quantity += 1;
    } else {
      current.push(product);
    }

    sessionStorage.setItem("cart", JSON.stringify(current));

    setShowAdded(true);
    setTimeout(() => {
      setShowAdded(false);
    }, 2000);
  };

  const productLink = getProductUrl(product);

  return (
    <article className="wishlist-card">
      <div className="wishlist-card__image">
        <img src={product.img} alt={product.title} />
      </div>

      <div className="wishlist-card__body">
        <div className="wishlist-card__copy">
          <p className="wishlist-card__title">{product.title}</p>
        </div>

        <p className="wishlist-card__price">
          {parseFloat(product.price).toLocaleString("en")} ден.
        </p>

        <div className="wishlist-card__actions">
          <Link
            to={productLink}
            className="wishlist-card__action wishlist-card__action--ghost"
          >
            <SearchIcon fontSize="small" />
            <span>{wishlistItemText.preview}</span>
          </Link>
          <button
            type="button"
            className="wishlist-card__action wishlist-card__action--primary"
            onClick={handleAddCartItem}
          >
            <AddShoppingCartIcon fontSize="small" />
            <span>{wishlistItemText.toCart}</span>
          </button>
          <button
            type="button"
            className="wishlist-card__icon"
            onClick={deleteItem}
            aria-label="Remove from wishlist"
          >
            <DeleteOutlineIcon fontSize="small" />
          </button>
        </div>
      </div>

      {showAdded ? (
        <div className="addtocart__popup">
          <Stack sx={{ width: "100%" }} spacing={2}>
            <Alert severity="success">
              <p>
                {product.title} {wishlistItemText.addedSuffix}{" "}
                <Link to="/cart" className="links">
                  {wishlistItemText.cart}
                </Link>
              </p>
            </Alert>
          </Stack>
        </div>
      ) : null}
    </article>
  );
}

export default WishlistSingle;
